import styled from "styled-components";

export const Container = styled.section`
  padding-top: 12%;
  display: flex;
  justify-content: space-between;
  gap: 6rem;
  background: rgba(0,0,0,0);
  min-height: 90vh;
  align-items: center;

  .hero-text {
    max-width: 650px;

    .greeting {
      font-size: 2.2rem;
      color: #c4c4c4;
      margin-bottom: 0.5rem;
      font-weight: 500;
      
      .name-highlight {
        background: linear-gradient(90deg, #667eea, #764ba2, #f093fb);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        font-weight: 700;
      }
      
      .wave-emoji {
        display: inline-block;
        animation: wave 2.5s infinite;
        transform-origin: 70% 70%;
      }
    }
    
    @keyframes wave {
      0% { transform: rotate(0deg); }
      10% { transform: rotate(14deg); }
      20% { transform: rotate(-8deg); }
      30% { transform: rotate(14deg); }
      40% { transform: rotate(-4deg); }
      50% { transform: rotate(10deg); }
      60% { transform: rotate(0deg); }
      100% { transform: rotate(0deg); }
    }

    h1 {
      font-size: 5.5rem;
      font-weight: 800;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      line-height: 1.1;
      margin-bottom: 0.3rem;
      text-shadow: 0 0 40px rgba(102, 126, 234, 0.3);
    }

    .company-tag {
      font-size: 1.3rem;
      color: #888;
      font-weight: 400;
      margin-bottom: 2rem;
      letter-spacing: 2px;
      text-transform: uppercase;
      
      &::before {
        content: '';
        display: inline-block;
        width: 30px;
        height: 2px;
        background: linear-gradient(90deg, #667eea, #764ba2);
        margin-right: 12px;
        vertical-align: middle;
      }
    }

    .intro-text {
      font-size: 1.6rem;
      line-height: 1.8;
      color: #c0c0c0;
      margin-bottom: 1.5rem;

      &.highlight {
        padding: 1.5rem;
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
        border-radius: 1rem;
        border-left: 3px solid #764ba2;
      }

      .gradient-text {
        background: linear-gradient(135deg, #667eea 0%, #f093fb 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        font-weight: 600;
      }

      em {
        color: #f093fb;
        font-style: normal;
        font-weight: 600;
      }
    }
  }

  .social-media {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    gap: 1.5rem;
    padding-top: 2rem;

    a {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 4.5rem;
      height: 4.5rem;
      border-radius: 1rem;
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
      border: 1px solid rgba(102, 126, 234, 0.3);
      transition: all 0.3s ease;

      &:hover {
        transform: translateY(-3px);
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.4) 0%, rgba(118, 75, 162, 0.4) 100%);
        box-shadow: 0 10px 20px rgba(102, 126, 234, 0.3);
      }
    }

    img {
      width: 2.2rem;
      height: 2.2rem;
    }
  }

  .button {
    margin-top: 2.5rem;
    padding: 1.4rem 4rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 3rem;
    font-size: 1.6rem;
    font-weight: 600;
    color: white;
    text-decoration: none;
    display: inline-block;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);

    &:hover {
      transform: translateY(-3px);
      box-shadow: 0 8px 25px rgba(102, 126, 234, 0.5);
    }
  }

  .hero-image {
    position: relative;

    .ai-card {
      position: relative;
      background: linear-gradient(135deg, rgba(15, 15, 26, 0.9) 0%, rgba(26, 26, 46, 0.9) 50%, rgba(22, 33, 62, 0.9) 100%);
      border-radius: 2rem;
      padding: 2rem;
      border: 1px solid rgba(102, 126, 234, 0.3);
      box-shadow: 0 20px 60px rgba(102, 126, 234, 0.2);
      overflow: hidden;
      transition: all 0.4s ease;

      &:hover {
        transform: translateY(-10px) scale(1.02);
        box-shadow: 0 30px 80px rgba(102, 126, 234, 0.35);
        border-color: rgba(102, 126, 234, 0.5);

        .ai-card-glow {
          opacity: 1;
        }
      }

      .ai-card-glow {
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(circle, rgba(102, 126, 234, 0.15) 0%, transparent 60%);
        opacity: 0.5;
        transition: opacity 0.4s ease;
        pointer-events: none;
      }

      .ai-image {
        width: 100%;
        max-width: 380px;
        border-radius: 1.5rem;
        margin-bottom: 1.5rem;
        filter: drop-shadow(0 10px 30px rgba(102, 126, 234, 0.3));
      }

      .ai-card-content {
        text-align: center;

        .terminal-container {
          background: #0d1117;
          border-radius: 12px;
          overflow: hidden;
          margin-bottom: 1.5rem;
          border: 1px solid rgba(102, 126, 234, 0.3);
          box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);

          .terminal-header {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 10px 14px;
            background: #161b22;
            border-bottom: 1px solid #30363d;

            .terminal-dot {
              width: 12px;
              height: 12px;
              border-radius: 50%;

              &.red { background: #ff5f56; }
              &.yellow { background: #ffbd2e; }
              &.green { background: #27ca40; }
            }

            .terminal-title {
              margin-left: auto;
              font-size: 0.85rem;
              color: #8b949e;
              font-family: 'Fira Code', 'Courier New', monospace;
            }
          }

          .terminal-body {
            padding: 15px;
            min-height: 100px;
            font-family: 'Fira Code', 'Courier New', monospace;
            font-size: 0.9rem;
            line-height: 1.6;
            text-align: left;

            .terminal-line {
              margin-bottom: 4px;

              &.command {
                color: #58a6ff;
              }

              &.output {
                color: #8b949e;
              }
            }

            .terminal-cursor {
              color: #58a6ff;
              animation: terminalBlink 1s step-end infinite;
            }

            @keyframes terminalBlink {
              0%, 50% { opacity: 1; }
              51%, 100% { opacity: 0; }
            }
          }
        }

        .stats-row {
          display: flex;
          justify-content: center;
          gap: 1.5rem;
          margin-bottom: 1.5rem;
        }

        .stat-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 1rem 1.5rem;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
          border-radius: 1rem;
          border: 1px solid rgba(102, 126, 234, 0.2);
          transition: all 0.3s ease;
          cursor: default;

          &:hover {
            transform: translateY(-3px);
            background: linear-gradient(135deg, rgba(102, 126, 234, 0.25) 0%, rgba(118, 75, 162, 0.25) 100%);
            border-color: rgba(102, 126, 234, 0.4);
          }

          .stat-icon {
            font-size: 1.8rem;
            margin-bottom: 0.3rem;
          }

          .stat-value {
            font-size: 1.4rem;
            font-weight: 700;
            color: #ffffff;
            background: linear-gradient(135deg, #667eea 0%, #f093fb 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .stat-label {
            font-size: 0.85rem;
            color: #b8b8ff;
            text-transform: uppercase;
            letter-spacing: 0.5px;
          }
        }

        .like-btn {
          cursor: pointer;
          border: none;
          outline: none;
          font-family: inherit;

          &.liked {
            background: linear-gradient(135deg, rgba(255, 100, 100, 0.2) 0%, rgba(255, 50, 100, 0.2) 100%);
            border-color: rgba(255, 100, 100, 0.4);

            .stat-value {
              background: linear-gradient(135deg, #ff6b6b 0%, #ff8e8e 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
            }
          }

          &:hover {
            transform: translateY(-3px) scale(1.05);
          }

          &:active {
            transform: scale(0.95);
          }
        }

        .status-indicator {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.8rem;
          padding: 0.8rem 1.5rem;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.15) 0%, rgba(118, 75, 162, 0.15) 100%);
          border-radius: 2rem;
          border: 1px solid rgba(102, 126, 234, 0.3);

          .pulse-dot {
            width: 10px;
            height: 10px;
            background: #667eea;
            border-radius: 50%;
            animation: statusPulse 2s ease-in-out infinite;
          }

          .typing-text {
            font-size: 1.1rem;
            font-weight: 600;
            font-family: 'Fira Code', 'Courier New', monospace;
            background: linear-gradient(135deg, #667eea 0%, #f093fb 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            background-clip: text;
          }

          .cursor {
            font-size: 1.2rem;
            color: #667eea;
            font-weight: 300;
            animation: blink 1s step-end infinite;
          }

          @keyframes blink {
            0%, 50% {
              opacity: 1;
            }
            51%, 100% {
              opacity: 0;
            }
          }
        }

        @keyframes statusPulse {
          0%, 100% {
            box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.6);
          }
          50% {
            box-shadow: 0 0 0 8px rgba(102, 126, 234, 0);
          }
        }

        p {
          font-size: 1.4rem;
          color: #b8b8ff;
          font-weight: 500;
          margin: 0;
        }
      }
    }

    @keyframes pulse {
      0%, 100% {
        box-shadow: 0 0 0 0 rgba(102, 126, 234, 0.4);
      }
      50% {
        box-shadow: 0 0 20px 5px rgba(102, 126, 234, 0.2);
      }
    }

    img {
      max-width: 450px;
      filter: drop-shadow(0 20px 40px rgba(102, 126, 234, 0.3));
    }
  }

  @media(max-width: 960px) {
    display: block;
    margin-top: 15%;
    text-align: center;

    .hero-text {
      max-width: 100%;

      h1 {
        font-size: 4rem;
      }

      h3 {
        font-size: 2rem;
      }

      .intro-text {
        text-align: left;
      }
    }

    .social-media {
      justify-content: center;
    }
    
    .hero-image {
      display: none;
    }
  }

  @media(max-width: 600px) {
    margin-top: 25%;
    padding-top: 5%;

    .hero-text {
      h1 {
        font-size: 3.2rem;
      }

      .greeting {
        font-size: 1.8rem;
      }
    }
  }

  @media(max-width: 480px) {
    margin-top: 30%;
  }
`